jQuery(($) => {
    const allTabs = $('body.ds .page-content .tabs-blocks').toArray();
    const switchTab = (tabs) => (event) => {
        if (event.target.classList.contains('active')) {
            return;
        }

        $('.tab-pill.active', tabs).removeClass('active');
        event.target.classList.add('active');
        $('.tab-content.active, .tab-content[data-tab-index="' + event.target.dataset.tabIndex + '"]', tabs)
            .toggleClass('active');
    };

    for (const tabs of allTabs) {
        $('.tab-pill', tabs).on('click', switchTab(tabs));
    }
});
